document.addEventListener('DOMContentLoaded', function() {
  // Select all back buttons in the sidebar navigation
  const backButtons = document.querySelectorAll('.nav-sidebar__back-button');
  
  // Add click event listener to each back button
  backButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      
      // Find the parent details element to close
      const parentDropdown = this.closest('.nav-sidebar__dropdown');
      const parentDetails = parentDropdown.closest('details');
      
      // Close the current dropdown by toggling the details element
      if (parentDetails) {
        parentDetails.removeAttribute('open');
      }
    });
  });
  
  // Handle opening of dropdowns (optional enhancement)
  const menuItems = document.querySelectorAll('.nav-sidebar__item--parent');
  menuItems.forEach(item => {
    if (item.parentElement.querySelector('details')) {
      item.addEventListener('click', function() {
        // Ensure proper focus management when opening dropdowns
        const details = this.parentElement.querySelector('details');
        if (details.hasAttribute('open')) {
          setTimeout(() => {
            const firstLink = details.querySelector('.nav-sidebar__dropdown a');
            if (firstLink) firstLink.focus();
          }, 100);
        }
      });
    }
  });
});